module.exports = __webpack_public_path__ + "img/en-slider_text_b1.2565fbd.7345ea04.png";